(function () {
  'use strict';
  const angular = window.angular;

  angular.module('app').config(CustomerRouter);

  CustomerRouter.$inject = ['$stateProvider'];

  function CustomerRouter($stateProvider) {
    $stateProvider
      .state('member.customer', {
        url: '/customer',
        authenticated: true,
        abstract: true,
        redirectTo: 'member.customer.list',
        ncyBreadcrumb: {
          skip: true,
        },
        resolve: {
          yoloClasses: [
            'RouterService',
            '$rootScope',
            (RouterService, $rootScope) => {
              return RouterService.getYoloClasses().then((classes) => {
                $rootScope.yoloClasses = classes;
                return classes;
              });
            },
          ],
        },
      })
      .state('member.customer.list', {
        url: '/',
        authenticated: true,
        component: 'customerList',
        ncyBreadcrumb: {
          label: '<span>{{"entities.organization.customer.modelNamePl"|translate}}</span>',
        },
        resolve: {
          countries: [
            'RouterService',
            function (RouterService) {
              return RouterService.getCountries();
            },
          ],
          timeZones: [
            'RouterService',
            function (RouterService) {
              return RouterService.getTimezones();
            },
          ],
        },
      })
      .state('member.customer.show', {
        url: '/:customerId',
        authenticated: true,
        template: '<ui-view></ui-view>',
        redirectTo: 'member.customer.show.home',
        resolve: {
          projects: [
            'RouterService',
            '$transition$',
            'navbarService',
            function (RouterService, $transition$, navbarService) {
              let params = $transition$.params();
              RouterService.storeId(params.customerId, 'Customer');
              return RouterService.getProjects(params).then((projects) => {
                navbarService.setProjects(projects);
                return projects;
              });
            },
          ],
          customer: [
            'RouterService',
            '$transition$',
            'AppUtils',
            'navbarService',
            '$rootScope',
            function (RouterService, $transition$, utils, navbarService, $rootScope) {
              let params = $transition$.params();
              return RouterService.getCustomer(params)
                .then((customer) => {
                  navbarService.setCustomer(customer);
                  return customer;
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, { redirectTo: 'member.home' });
                });
            },
          ],
          managerCount: [
            'RouterService',
            '$transition$',
            (RouterService, $transition$) => {
              let params = $transition$.params();
              return RouterService.getManagersCount(params);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.customer.name}}',
        },
      })
      .state('member.customer.show.home', {
        url: '/',
        redirectTo: 'member.customer.show.home.projects',
        controller: [
          'customer',
          function (customer) {
            this.customer = customer;
          },
        ],
        controllerAs: 'ctrl',
        template:'<div class="page-header"><h1 class="no-margin"><i class="fas fa-id-card fa-fw"></i> <span class="header-text">{{ctrl.customer.name}}</span></h1><div class="container"><ul class="nav nav-tabs nav-justified"><li ui-sref-active="active"><a ui-sref="member.customer.show.home.projects" translate>entities.project.modelNamePl</a></li><li ui-sref-active="active"><a ui-sref="member.customer.show.home.profile" translate>entities.organization.customer.modelName</a></li></ul></div></div><div class="container"><ui-view></ui-view></div>',
        ncyBreadcrumb: { skip: true },
      })
      .state('member.customer.show.home.projects', {
        url: 'project',
        authenticated: true,
        component: 'customerProjects',
        ncyBreadcrumb: { label: '<span>{{"entities.project.modelNamePl"|translate}}</span>' },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/editors/simplemde.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
              ]);
            },
          ],
        },
      })
      .state('member.customer.show.home.profile', {
        url: 'profile',
        authenticated: true,
        component: 'customerProfile',
        ncyBreadcrumb: { label: '<span>{{"entities._all.profile" | translate}}</span>' },
        resolve: {
          users: [
            'RouterService',
            'Customer',
            '$transition$',
            'AppUtils',
            '$rootScope',
            function (RouterService, Customer, $transition$, utils, $root) {
              let params = $transition$.params();

              return RouterService.getManagers(params).catch((err) => {
                throw utils.getHTTPError(err, {
                  redirectTo: 'member.customer.show.home',
                  params: { customerId: params.customerId },
                });
              });
            },
          ],
          countries: [
            'RouterService',
            function (RouterService) {
              return RouterService.getCountries();
            },
          ],
          timeZones: [
            'RouterService',
            function (RouterService) {
              return RouterService.getTimezones();
            },
          ],
        },
      })
      .state('member.customer.show.dataDisplay', {
        url: '/data-display/:projectId/:assetId/:sensorId?:dataId&:zoneFilter',
        component: 'monitoringDataDisplay',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Data Display',
        },
        resolve: {
          project: [
            '$transition$',
            'navbarService',
            'AppUtils',
            'RouterService',
            function ($transition$, navbarService, utils, RouterService) {
              let params = $transition$.params();
              RouterService.storeId(params.projectId, 'Customer$CurrentProject');
              return RouterService.getProject(params)
                .then((project) => {
                  navbarService.setProject(project);
                  return project;
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.customer.show.home',
                    params: { customerId: params.customerId },
                  });
                });
            },
          ],
        },
      });
  }
})();
